import React, { useMemo } from "react";

import { formatDate } from "../../services/date";

import InternalModal from "../../commons/InternalModal";

import Table from "./Table";
import ValueRow from "./ValueRow";

const mapAverageColumns = (average) => [
  formatDate(average?.date),
  parseFloat(average?.value).toFixed(3)
];

const TeamHealthDetailsModal = ({ composition, average, onClose }) => {

  const columns = useMemo(() => [
    {
      id: "name",
      accessorKey: "name",
      header: () => <span>{I18n.t("insights.page.table.member_name.title")}</span>,
      cell: info => info.getValue(),
      sortUndefined: "last",
      sortDescFirst: false
    },
    {
      id: "date",
      accessorKey: "date",
      header: () => <span>{I18n.t("insights.page.table.date.title")}</span>,
      cell: info => info.getValue() ? formatDate(info.getValue()) : null,
      sortUndefined: "last",
      sortDescFirst: false
    },
    {
      id: "value",
      accessorKey: "value",
      header: () => <span>{I18n.t("insights.page.table.value.title")}</span>,
      cell: info => parseFloat(info.getValue()).toFixed(3),
      sortUndefined: "last",
      sortDescFirst: false
    }
  ], []);

  const renderContent = () => composition && (
    <div className="content">
      <Table
        columns={columns}
        data={composition}
        loading={false}
      />
      <ValueRow
        title={I18n.t("insights.page.table.team_average.title")}
        columns={mapAverageColumns(average)}
      />
    </div>
  );

  return (
    <InternalModal
      type="team-health-details"
      isModalOpen={Boolean(composition)}
      hideModal={onClose}
      showModalBody={false}
      component={renderContent()}
      backdrop
    />
  );
}

export default TeamHealthDetailsModal;
